import { ampli, BrowserClient, Environment, LoadOptions } from "src/ampli"
import { plugin as sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser'
import { events } from 'src/engagement/events'
import React, { createContext, FC, ReactNode, useLayoutEffect, useState } from "react"

const { GATSBY_AMPLITUDE_ENVIRONMENT } = process.env

export type Context = { client: BrowserClient | undefined }

export const AmplitudeContext = createContext<Context>({
  client: undefined,
})

export const AmplitudeProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [client, setClient] = useState<BrowserClient | undefined>(undefined)

  useLayoutEffect(() => {
    if (!ampli.isLoaded) {
      const loadConfig: LoadOptions = {
        environment: GATSBY_AMPLITUDE_ENVIRONMENT as Environment,
        client: { configuration: { defaultTracking: true } },
      }
      console.log('Initializing Ampli with', { loadConfig })
      const result = ampli.load(loadConfig)
      result.promise.then(() => {
        const sessionReplayTracking = sessionReplayPlugin()
        ampli.client.add(sessionReplayTracking)
        setClient(ampli.client)
        events.emit('ready', ampli.client)
      })
    }
  }, [])

  if (!client) {
    return <div>Loading AmplitudeContext...</div>
  }

  return (
    <AmplitudeContext.Provider value={{ client: client }}>
      {children}
    </AmplitudeContext.Provider>
  )
}
